import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Auth from './components/Auth'
import ReviewPage from './containers/ReviewPage'
import StandaloneDocumentViewer from './containers/StandaloneDocumentViewer'
import configureStore from './store/configureStore'
import App from './App'
import * as serviceWorker from './serviceWorker'

import './index.scss'
import '../node_modules/jquery/dist/jquery.slim'
import '../node_modules/bootstrap/dist/js/bootstrap'

const store = configureStore()
const rootElement = document.getElementById('root')

// Public reviewer and shared-file pages bypass all Auth/Redux initialisation.
// Mounting the full App/Auth wrapper on public paths causes OIDC / /api/profile (401)
// to redirect unauthenticated users to /signin before the public viewer can render.
if (window.location.pathname.startsWith('/review/') || window.location.pathname.startsWith('/shared/file/')) {
  ReactDOM.render(
    <Router>
      <Switch>
        <Route path="/review/:token" component={ReviewPage} />
        <Route path="/shared/file/:token" component={StandaloneDocumentViewer} />
      </Switch>
    </Router>,
    rootElement,
  )
} else {
  ReactDOM.render(
    <Provider store={store}>
      <Auth>
        <App />
      </Auth>
    </Provider>,
    rootElement,
  )
}

serviceWorker.unregister()
